const ModalTypes = Object.freeze({
  GIFT_DETAILS: 'GIFT_DETAILS',
  GIFT_WINNERS: 'GIFT_WINNERS',
  WINNER_GIFTS: 'WINNER_GIFTS',
  FILTER_MEMBERS: 'FILTER_MEMBERS',
});

export default ModalTypes;
